export enum RoleType {
    Checks_Calendar = "Checks_Calendar",
    Checks_Customer = "Checks_Customer",
    Checks_Bom = "Checks_Bom",
    Checks_Order_Inventory = "Checks_Order_Inventory",
    Checks_Item = "Checks_Item",
    Checks_Order_Manufacturing = "Checks_Order_Manufacturing",
    Checks_Subresource = "Checks_Subresource",
    Checks_Operation_Export = "Checks_Operation_Export",
    Checks_Operation = "Checks_Operation",
    Checks_Output = "Checks_Output",
    Checks_Order_Purchase = "Checks_Order_Purchase",
    Checks_Resource = "Checks_Resource",
    Checks_Routing = "Checks_Routing",
    Checks_Order_Sales = "Checks_Order_Sales",
    Checks_Shift = "Checks_Shift",
    Checks_Miscellaneous_One = "Checks_Miscellaneous_One",
    Checks_Miscellaneous_Two = "Checks_Miscellaneous_Two",
    Checks_Order_Export = "Checks_Order_Export",
    Archivation = "Archivation",
    Base_Report = "Base_Report",
    Notification = "Notification",
    Transformation = "Transformation",
    Plan_Vs_Reality = "Plan_Vs_Reality",
    PMT = "PMT",
    ApiAccess_Default = "ApiAccess_Default",
    Administrator_Full = "Administrator_Full",
    Reports_Work_Queue = "Reports_Work_Queue",
    Reports_Load_Graph = "Reports_Load_Graph",
    Reports_Inventory_Graph = "Reports_Inventory_Graph",
    Reports_Operators = "Reports_Operators",
    Configurations = "Configurations",
    Configurations_Write = "Configurations_Write",
    Configurations_Edit = "Configurations_Edit",
    EntityMetadata_Write = "EntityMetadata_Write",
    EntityMetadata_Edit = "EntityMetadata_Edit",
    Monitoring_Event_Read = "Monitoring_Event_Read",
    AuditTrail_Check_Start = "AuditTrail_Check_Start",
    AuditTrail_Checks_Read = "AuditTrail_Checks_Read",
    AuditTrail_Data_Modifier = "AuditTrail_Data_Modifier",
    AuditTrail_Changes_Controllor = "AuditTrail_Changes_Controllor",
    AuditTrail_Logs_Read = "AuditTrail_Logs_Read",
    AuditTrail_Changes_Read = "AuditTrail_Changes_Read",
    AuditTrail_CheckFinishedNotification = "AuditTrail_CheckFinishedNotification",
    AuditTrail_CalculatingFinishedNotification = "AuditTrail_CalculatingFinishedNotification",
    AuditTrail_Logs_Approve = "AuditTrail_Logs_Approve",
    Solver_Jobs_Supervisor = "Solver_Jobs_Supervisor",
    Solver_User = "Solver_User",
    Solver_Jobs_Edit = "Solver_Jobs_Edit",
    Solver_JobResultMetadata_Write = "Solver_JobResultMetadata_Write",
    Solver_InputDataSets_Write = "Solver_InputDataSets_Write",
    Solver_ResultSets_Write = "Solver_ResultSets_Write",
    Solver_JobConfigurations_Write = "Solver_JobConfigurations_Write",
    Solver_Jobs_Write = "Solver_Jobs_Write",
    DataStreamMessage_AllowedOrigins_Read = "DataStreamMessage_AllowedOrigins_Read",
    DataStreamMessage_AllowedOrigins_Write = "DataStreamMessage_AllowedOrigins_Write"

}